<template>
  <div>
    <div v-if="!position && !loading">
      <p>{{ this.payload.title }}</p>
      <button class="button is-info" @click="fetchPosition">
         Show Position Entity
      </button>
    </div>
    <p v-if="loading">Loading Position...</p>
    <LinkEntity
      v-if="position"
      :payload="position"
      :additional_data="{ resource_type: 'Position' }" />
    <GhanaFlag
      v-if="position"
      :payload="position"
      :additional_data="{ resource_type: 'Position' }"
      :eager_load="true"
      :sent_applicants="true" />
  </div>
</template>
<script>
import LinkEntity from '@/components/LinkEntity'
import GhanaFlag from '@/components/GhanaFlag'
export default {
  name: 'outsource-position-link-entity',
  components: {
    LinkEntity,
    GhanaFlag
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      position: null,
      loading: false
    }
  },
  methods: {
    async fetchPosition () {
      this.loading = true
      this.position = await this.$network_utils.getPosition({ id: this.payload.id })
      this.loading = false
    }
  }
}
</script>
